import { LoginClearPreloadedData } from '../login/types';
import * as Bixby from './../../core';

export interface TransactionCompsState {
  transactionComps?: Bixby.Models.CompanyTransactionComp[];
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
}

export const TRANSACTION_COMPS_LOADING = 'TRANSACTION_COMPS_LOADING';
export const TRANSACTION_COMPS_SUCCESS = 'TRANSACTION_COMPS_SUCCESS';
export const TRANSACTION_COMPS_FAILURE = 'TRANSACTION_COMPS_FAILURE';

interface TransactionCompsLoading extends Bixby.Models.BixbyAction<undefined, typeof TRANSACTION_COMPS_LOADING> {
  type: typeof TRANSACTION_COMPS_LOADING;
}

interface TransactionCompsSuccess
  extends Bixby.Models.BixbyAction<Bixby.Models.CompanyTransactionComp[], typeof TRANSACTION_COMPS_SUCCESS> {
  type: typeof TRANSACTION_COMPS_SUCCESS;
  payload: Bixby.Models.CompanyTransactionComp[];
}

interface TransactionCompsFailure
  extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof TRANSACTION_COMPS_FAILURE> {
  type: typeof TRANSACTION_COMPS_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type TransactionCompsActionTypes =
  | TransactionCompsLoading
  | TransactionCompsSuccess
  | TransactionCompsFailure
  | LoginClearPreloadedData;
